<script lang="ts">
export default {
    name: "Menu",
    inheritAttrs: false,
};  
</script>
<script setup lang="ts">
import { info } from '@/lib/init';
import Menu from '@/tiers/frontend/apps/Menu.vue';
import { onMounted, ref } from 'vue';
import Collapse from '@/components/Collapse.vue';
import Accordion from '@/components/Accordion.vue';

interface Item {
    label: string;
    url: string;
    sub: Item[];
    active?: boolean;
}

interface Props {
    list: Item[];
    location?: string;
    sub?: boolean;
    socials?: boolean;
    click?: boolean
}

const { list, location, sub, socials, click } = withDefaults(defineProps<Props>(), {
    location: '',
    sub: false,
    socials: false,
    click: false,
})

const data = ref<Item[]>(list.map((item: Item) => {
    item.active = false
    return item
}))

const toggle = (index: number, item: Item) => {
    if (data.value[index].sub?.length > 0) {
        if (!data.value[index].active) {
            data.value.map(item => {
                item.active = false;
            });
        }
        data.value[index].active = !data.value[index].active

    } else {
        if (click) {
            document.location.href = item.url
        }
    }

}


</script>
<style scoped lang="scss">
@import "@scss/config/config";
@import "@scss/bootstrap";
@import "@scss/mixins/responsive";

ul {
    padding: 0;
}

.social-medias {
    .facebook {
        &::before {
            content: "";
            width: 3rem;
            height: 3rem;
            display: block;
            background: url('#{$imagesPath}/icon-facebook.svg') no-repeat center;
            background-size: contain;
            position: relative;
        }
    }

    .linkedin {
        &::before {
            content: "";
            width: 3rem;
            height: 3rem;
            display: block;
            background: url('#{$imagesPath}/icon-linkedin.svg') no-repeat center;
            background-size: contain;
            position: relative;
        }
    }

    .twitter {
        &::before {
            content: "";
            width: 3rem;
            height: 3rem;
            display: block;
            background: url('#{$imagesPath}/icon-twitter.svg') no-repeat center;
            background-size: contain;
            position: relative;
        }
    }
}
</style>
<template>
    <ul v-if="sub" class="sub-menu" v-bind="$attrs">
        <li v-for="(item, i) in  data" :key="i" class="menu-item sub-menu-item">
            <template v-if="click">
                <a @click.prevent="toggle(i, item)" :class="{ 'active': item.active }" :href="item.url">{{ item.label }}
                </a>
            </template>
            <template v-else>
                <a @mouseover="toggle(i, item)" @mouseleave="toggle(i, item)" :class="{ 'active': item.active }"
                    :href="item.url">{{ item.label }}
                </a>
            </template>

            <!-- <Menu v-show="data[i].active && data[i].sub?.length > 0" :list="item.sub" sub></Menu> -->
            <Menu v-if="data[i].sub?.length > 0" :class="{ 'opened': data[i].active && data[i].sub?.length > 0 }"
                :list="item.sub" sub></Menu>
        </li>
    </ul>
    <div v-else class="menu" :class="[location != '' ? location + '-menu' : 'main-menu']">
        <div class="container-menu">
            <ul class="parent-menu">
                <template v-for="(item, i) in  data" :key="i">
                    <li class="menu-item" :class="{ 'menu-item-active': item.active }">
                        <template v-if="click">
                            <a @click.prevent="toggle(i, item)" :class="{ 'active': item.active }" :href="item.url">{{
                                item.label }}
                            </a>
                        </template>
                        <template v-else>
                            <a @mouseover="toggle(i, item)" @mouseleave="toggle(i, item)" :class="{ 'active': item.active }"
                                :href="item.url">{{ item.label }}
                            </a>
                        </template>

                        <!-- <Menu v-show="data[i].active && data[i].sub?.length > 0" :list="item.sub" sub></Menu> -->
                        <Menu v-if="data[i].sub?.length > 0"
                            :class="{ 'opened': data[i].active && data[i].sub?.length > 0 }" :list="item.sub" sub>
                        </Menu>
                    </li>
                </template>
            </ul>
            <template v-if="socials">
                <div class="social-medias">
                    <a href="https://www.instagram.com/codendot.cnd/" class="facebook" target="_blank"></a>
                    <a href="https://www.facebook.com/CodenDot" class="linkedin" target="_blank"></a>
                    <a href="https://www.linkedin.com/company/codendot" class="twitter" target="_blank"></a>
                </div>
            </template>
        </div>
    </div>
</template>
